import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
  overflow: auto;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: Lato, sans-serif;
`;

export const Thead = styled.thead`
  background-color: #f5f5f5;
  
  th {
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    color: #333;
    border-bottom: 2px solid #e0e0e0;
    white-space: nowrap;
  }
`;

export const Tbody = styled.tbody`
  tr {
    &:hover {
      background-color: #f8f9fa;
    }
    
    &:not(:last-child) {
      border-bottom: 1px solid #e0e0e0;
    }
  }

  td {
    padding: 12px 16px;
    font-size: 14px;
    color: #424242;
  }
`;

export const TablePagination = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid #e0e0e0;
  font-family: Lato, sans-serif;
  font-size: 14px;
  
  button {
    margin: 0 4px;
    padding: 6px 12px;
    border: 1px solid #e0e0e0;
    background: white;
    border-radius: 4px;
    cursor: pointer;
    font-family: Lato, sans-serif;
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    
    &:hover:not(:disabled) {
      background: #f5f5f5;
    }
  }
`;

export const TableCell = styled.td<{ align?: 'left' | 'center' | 'right' }>`
  text-align: ${props => props.align || 'left'};
  padding: 12px 16px;
  font-size: 14px;
  color: #424242;
`;

export const SortIcon = styled.span`
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 8px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #666;
  vertical-align: middle;
`;